import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Amplify } from 'aws-amplify';
import { initializeApp, FirebaseApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword, onAuthStateChanged, signOut, Auth} from "firebase/auth";
import { from, of } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { map, catchError, shareReplay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class FirebaseAuthService {
    constructor() {
        this.firebaseApp = initializeApp(environment.firebaseConfig)
        this.auth = getAuth(this.firebaseApp);
    }

    firebaseApp: FirebaseApp;
    auth: Auth;
    /**
     * Validar erros
     * https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/API_InitiateAuth.html#API_InitiateAuth_Errors
     */
    login(username: string, password: string): Observable<unknown> {
        return from(signInWithEmailAndPassword(this.auth, username, password));
    }


    //observable that emits authentication state changes
    private authState$ = new Observable<boolean>(observer => {
    const unsub = onAuthStateChanged(this.auth, user => {
        observer.next(!!user);
    });

    return () => unsub();
    }).pipe(
    shareReplay({ bufferSize: 1, refCount: true })
    );

    isAuthenticated(): Observable<boolean> {
    return this.authState$;
    }

    logout(): Observable<void> {
        const auth = getAuth();
        return from(signOut(auth));
    }

    getJwt(): Observable<string | null> {

         const user = this.auth.currentUser;

        if (!user) {
            return of(null);
        }
        // return from(this.auth.currentUser?.getIdToken(/* forceRefresh */ true));
        return from(this.auth.currentUser?.getIdToken()).pipe(
            map(response => {
                if (response) {
                    return response;
                }
                return null;
            })
        );
    }
}
